import ApplyConversationActionContext from 'owa-mail-store/lib/store/schema/ApplyConversationActionContext';
import { getApplyConversationActionContext } from 'owa-mail-list-store';

/**
 * Gets contextual information for ApplyConversationAction for a given conversation
 */
export default function getUniqueConversationContextsForRowKey(
    rowKeys: string[],
    tableViewId: string
): ApplyConversationActionContext[] {
    const conversationActionContexts = [];
    const rowIds: { [id: string]: boolean } = {};

    rowKeys.forEach(rowKey => {
        const conversationContext = getApplyConversationActionContext(rowKey, tableViewId);

        // Do not add contexts for duplicate row Ids
        if (!rowIds[conversationContext.conversationId]) {
            rowIds[conversationContext.conversationId] = true;
            conversationActionContexts.push(conversationContext);
        }
    });

    return conversationActionContexts;
}
